import Survey from "@/survey/model/Survey";

const DB_NAME = 'survey_db';

export class SurveyRepository {
    private storeName = 'surveys';
    private db: IDBDatabase | null = null;

    public initDB(): Promise<void> {
        const request = indexedDB.open(DB_NAME, 1);
        request.onupgradeneeded = (event) => {
            const db = (event.target as IDBOpenDBRequest).result;
            if (!db.objectStoreNames.contains(this.storeName)) {
                db.createObjectStore(this.storeName, {
                    keyPath: 'id',
                    autoIncrement: true,
                });
            }
        };
        return new Promise((resolve, reject) => {
            request.onsuccess = () => {
                this.db = request.result;
                resolve();
            };
            request.onerror = () => {
                console.error('IndexedDB error:', request.error);
                reject(request.error);
            };
        });
    }

    private getStore(mode: IDBTransactionMode): IDBObjectStore {
        if (!this.db)
            throw new Error('Database is not initialized.');
        const tx = this.db.transaction(this.storeName, mode);
        return tx.objectStore(this.storeName);
    }

    public async addSurveyGetId(data: Omit<Survey, 'id' | 'createdAt'>): Promise<number> {
        return new Promise((resolve, reject) => {
            if (!this.db)
                return reject('Database not ready');
            const store = this.getStore('readwrite');
            const timestampedData: Survey = {
                ...data,
                createdAt: new Date().toISOString(),
            };
            const request = store.add(timestampedData);
            request.onsuccess = () => resolve(request.result as number);
            request.onerror = () => reject(request.error);
        });
    }

    public async getAllSurveys(): Promise<Survey[]> {
        return new Promise((resolve, reject) => {
            if (!this.db)
                return reject('Database not ready');
            const store = this.getStore('readonly');
            const request = store.getAll();
            request.onsuccess = () => resolve(request.result as Survey[]);
            request.onerror = () => reject(request.error);
        });
    }

    public async deleteSurvey(id: number): Promise<void> {
        return new Promise((resolve, reject) => {
            if (!this.db)
                return reject('Database not ready');
            const store = this.getStore('readwrite');
            const request = store.delete(id);
            request.onsuccess = () => resolve();
            request.onerror = () => reject(request.error);
        });
    }

    public dispose(): void {
        if (this.db) {
            this.db.close();
            this.db = null;
        }
    }
}
